<script lang="ts">
  import { getImageAttributes, type ImageAttributesOptions } from '$lib/utils/cms';
  import type { AssetStoryblok, MultiassetStoryblok } from '$types/bloks';

  import Image from './image.svelte';
  import { buildSrcSet, buildSizes, type SrcSetConfig, type SizesConfig } from '$lib/image';

  export let image: AssetStoryblok | MultiassetStoryblok[0];
  export let options: Partial<ImageAttributesOptions> | undefined = undefined;
  export let widths: SrcSetConfig['widths'] | undefined = undefined;
  export let sizes: string | SizesConfig<string> | undefined = undefined;
  export let loader: SrcSetConfig['loader'] = ({ width }) => {
    return getImageAttributes(image, { size: [width, 0] }).src;
  };

  const imageAttributes = getImageAttributes(image, options);

  $: srcset =
    buildSrcSet({
      loader: loader,
      widths: widths ?? [$$props.width || null]
    }) || undefined;
</script>

<Image
  {...imageAttributes}
  alt={imageAttributes.alt}
  {srcset}
  sizes={typeof sizes === 'string' ? sizes : sizes ? buildSizes(sizes) : undefined}
  {...$$restProps}
/>
